import React from "react";
import { currency } from "../../pages/admin/reports/filterUtils";
interface SalesSummaryCardsProps {
  totalOrders: number;
  totalRevenue: number;
  onlineOrders: number;
  instoreOrders: number;
}

const SalesSummaryCards: React.FC<SalesSummaryCardsProps> = ({
  totalOrders,
  totalRevenue,
  onlineOrders,
  instoreOrders,
}) => {
  const cards = [
    { label: "Total Orders", value: totalOrders.toString() },
    { label: "Total Revenue", value: currency(totalRevenue) },
    { label: "Online Orders", value: onlineOrders.toString() },
    { label: "In-store Orders", value: instoreOrders.toString() },
  ];

  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
        >
          <p className="mb-1 text-xs font-semibold text-blue-600">
            {card.label}
          </p>
          <p className="text-2xl font-bold text-gray-800">{card.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SalesSummaryCards;
